import styled from 'styled-components';

export const BannerCard = styled.div`
    flex-basis: 60%;
    margin-left: 30px;
`;

export const Banner = styled.div`
  background-color: #172647;
  color: white;
  text-align: center;
  padding: 90px 20px;
  font-size: 36px;
`;

export const CoursesContainer = styled.div`
  background-color: #F7F9FF;
  padding: 90px 0px;
`;

export const AboutContainer = styled.div`
  position: relative;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 12px;
  width: 80%;
  margin: 0 10%;
  top: -200px;
`;

export const AboutContainerAboutPage = styled.div`
  border-radius: 12px;
  paddingLeft: 20px;
`;

export const Header = styled.div`
  padding: 40px 20px;
  font-size: 24px;
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.button`
  background: #FFAB00 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  border: none;
  margin-top: 10px;
  height: 30px;
  cursor: pointer;
  padding: 0px 10px;
  color: white;
  font-weight: bold;
`;
